export default {"src":"/statics/ecommerce/_next/static/media/disney.72407878.svg","height":29,"width":40,"blurWidth":0,"blurHeight":0};